import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

// Fungsi helper untuk ubah tanggal ke format Indonesia
const formatTanggalID = (datetimeString) => {
  if (!datetimeString) return "";
  const date = new Date(datetimeString.replace(" ", "T"));
  return new Intl.DateTimeFormat("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

const News = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE;

  // 🔹 Fetch detail post dari API
  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await fetch(`${API_BASE}/news.php?action=detail&id=${id}`);
        const json = await res.json();
        if (json.data) {
          setPost(json.data);
        } else {
          setPost({ title: "Tidak ditemukan", content: "Post tidak tersedia." });
        }
      } catch (error) {
        setPost({ title: "Error", content: "Gagal memuat post." });
      }
    };

    fetchPost();
  }, [id]);

  // 🔹 Fetch daftar post terkait (bisa nanti kamu ubah endpoint-nya)
  useEffect(() => {
    const fetchRelated = async () => {
      try {
        const res = await fetch(`${API_BASE}/news.php?action=list`);
        const json = await res.json();
        setRelatedPosts(json.data || []);
      } catch (error) {
        console.error("Gagal memuat post terkait", error);
      }
    };

    fetchRelated();
  }, []);

  if (!post) return <p>Loading...</p>;

  return (
    <div>
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12" style={{ textAlign: 'left' }}>
                <div className="page-title-heading">
                  <h2 className="title">{post.title}</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span><a className="pathway" href="/">Home</a></span>
                  <span><a className="pathway" href="#"> Berita</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-main">
        <div className="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-8 content-area" style={{ textAlign: 'left' }}>
                <article className="post ttm-blog-single clearfix">
                  <div className="ttm-blog-single-content">
                    <div class="ttm-post-entry-header">
                        <div class="post-meta">
                            <span class="ttm-meta-line byline">
                                <i class="ti ti-user"></i>{post.username}</span>
                            <span class="ttm-meta-line tags-links">
                                <i class="ti ti-calendar"></i> {formatTanggalID(post.created_at)}</span>
                        </div>
                    </div>

                    {/* 🔹 tampilkan konten HTML dari Quill */}
                    <div
                      className="post-content"
                        style={{  paddingLeft: 0,  marginLeft: 0, overflow: "hidden",  wordWrap: "break-word"}}
                       dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                  </div>
                </article>
              </div>

              {/* 🔹 Sidebar post terkait */}
              <div className="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey mt_60 pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                <aside className="widget widget-recent-post with-title" style={{ textAlign: 'left' }}>
                  <h3 className="widget-title">Berita Terkait</h3>
                  <ul className="widget-post ttm-recent-post-list">
                    {relatedPosts.slice(0, 5).map((item) => (
                      <li key={item.id}>
                        <span className="post-date">{formatTanggalID(item.created_at)}</span>
                        <Link to={`/berita/${item.id}`}> {item.title}</Link>
                      </li>
                    ))}
                  </ul>
                </aside>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
